<div class="info-title">{{ 'Settings.CompanyData' | translate }}</div>
<div class="info-details">{{ 'Settings.RequiredFieldsDetails' | translate }}</div>
<div class="info-details" style="padding-bottom: 20px">{{ 'Settings.RequiredFieldsDetails_2' | translate }}</div>

<form *ngIf="editInfoForm" [formGroup]="editInfoForm" (ngSubmit)="onSubmit()">
  <div class="expanded-info-parent">
    <div class="expanded-info-column">
      <div class="expanded-info-title" matTooltip="{{ 'Shared.Mandatory' | translate }}">
        {{ ('Settings.Company' | translate) + '*' }}
      </div>
      <input
        required
        formControlName="name"
        class="expanded-info-input"
        (ngModelChange)="onCompanyNameChange($event)"
        [(ngModel)]="companiesService.currentCompany.name"
      />
      <div *ngIf="getError('name')" class="expanded-info-detail error">
        <span *ngIf="getErrorType('name', 'required')">{{ 'Settings.ErrorControl.RequiredField' | translate }}</span>
      </div>
    </div>

    <div class="expanded-info-column">
      <div class="expanded-info-title" matTooltip="{{ 'Shared.Mandatory' | translate }}">
        {{ ('Settings.EmailAdmin' | translate) + (isEdit() ? '' : '*') }}
      </div>
      <input
        class="expanded-info-input"
        [required]="!isEdit()"
        formControlName="email"
        [(ngModel)]="companiesService.currentCompany.email"
      />
      <div *ngIf="getError('email')" class="expanded-info-detail error">
        <span *ngIf="getErrorType('email', 'required')">{{ 'Settings.ErrorControl.RequiredField' | translate }}</span>
        <span *ngIf="getErrorType('email', 'invalidParam')">{{ 'Settings.ErrorControl.EmailFormat' | translate }}</span>
      </div>
    </div>

    <div *ngIf="roleAllowed()" class="expanded-info-column">
      <div class="expanded-info-title" matTooltip="{{ 'Shared.Mandatory' | translate }}">
        {{ ('Settings.EzvizAccount' | translate) + '*' }}
      </div>
      <input
        *ngIf="isEzvizAccountDisabled === 'ezviz-enabled'"
        class="expanded-info-input"
        required
        formControlName="ezvizAccountName"
        [(ngModel)]="companiesService.currentCompany.ezvizAccountName"
      />
      <input
        *ngIf="isEzvizAccountDisabled === 'ezviz-disabled'"
        class="expanded-info-input"
        required
        disabled
        formControlName="ezvizAccountName"
        [(ngModel)]="companiesService.currentCompany.ezvizAccountName"
      />
      <div *ngIf="getError('ezvizAccountName')" class="expanded-info-detail error">
        <span *ngIf="getErrorType('ezvizAccountName', 'required')">{{
          'Settings.ErrorControl.RequiredField' | translate
        }}</span>
        <br />
        <span *ngIf="getErrorType('ezvizAccountName', 'invalidParam')">{{
          'Settings.ErrorControl.EzvizAccountNameFormat' | translate
        }}</span>
      </div>
    </div>
  </div>

  <div class="expanded-info-parent">
    <div class="expanded-info-column">
      <div class="expanded-info-title" matTooltip="{{ 'Settings.WhatsappNumber' | translate }}">
        {{ ('Settings.Country' | translate) + '* ' }}
      </div>
      <app-input-phone-number-with-flag
        [country]="companiesService?.currentCompany?.country?.iso"
        [whatsappNumberInput]="companiesService.currentCompany.whatsappNumber"
        (countryChange)="onSelectCountry($event)"
        (phoneChange)="onPhoneChange($event)"
      ></app-input-phone-number-with-flag>
      <div *ngIf="getError('country')" class="expanded-info-detail error">
        <span *ngIf="getErrorType('country', 'required')">{{ 'Settings.ErrorControl.RequiredField' | translate }}</span>
      </div>
    </div>

    <div class="expanded-info-column">
      <div class="expanded-info-title" matTooltip="{{ 'Settings.Contact' | translate }}">
        {{ 'Settings.Contact' | translate }}
      </div>
      <input
        class="expanded-info-input"
        formControlName="contact"
        [(ngModel)]="companiesService.currentCompany.contact"
      />
      <div *ngIf="getError('contact')" class="expanded-info-detail error">
        <span *ngIf="getErrorType('contact', 'invalidParam')">
          {{ 'Settings.ErrorControl.EmailFormat' | translate }}
        </span>
      </div>
    </div>
    <div class="expanded-info-column">
      <div class="expanded-info-title" matTooltip="{{ 'Settings.NotificationEmail' | translate }}">
        {{ 'Settings.NotificationEmail' | translate }}
      </div>
      <input class="expanded-info-input" formControlName="notificationEmail" [(ngModel)]="notificationEmail" />
      <div *ngIf="getError('notificationEmail')" class="expanded-info-detail error">
        <span *ngIf="getErrorType('notificationEmail', 'invalidParam')">{{
          'Settings.ErrorControl.EmailFormat' | translate
        }}</span>
      </div>
    </div>
  </div>

  <div class="expanded-info-parent">
    <div class="expanded-info-column">
      <div class="expanded-info-title" matTooltip="{{ 'Settings.Language' | translate }}">
        {{ 'Settings.Language' | translate }}
      </div>
      <mat-form-field appearance="none" class="remove-infix no-bottom-padding">
        <mat-select
          name="language"
          #selectedLanguageRef
          [value]="companiesService.currentCompany.language"
          class="text-style-input expanded-info-input"
          (selectionChange)="setLanguage($event.value)"
          style="width: 300px"
        >
          <mat-option class="text-style-input" [value]="lang" *ngFor="let lang of languages">
            {{ 'Settings.Languages.' + lang | translate }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="expanded-info-column">
      <div
        class="expanded-info-title"
        matTooltip="{{ ('Settings.WebLink' | translate) + ' (' + ('Settings.WebLinkDetails' | translate) + ')' }}"
      >
        {{ 'Settings.WebLink' | translate }}
      </div>
      <input
        class="expanded-info-input"
        formControlName="webUrl"
        placeholder="example.com"
        [(ngModel)]="companiesService.currentCompany.webUrl"
      />
      <div *ngIf="getError('webUrl')" class="expanded-info-detail error">
        <span *ngIf="getErrorType('webUrl', 'invalidParam')">{{ 'Settings.ErrorControl.UrlFormat' | translate }}</span>
      </div>
    </div>

    <div class="expanded-info-column">
      <div class="expanded-info-title" matTooltip="{{ 'Settings.LinkName' | translate }}">
        {{ 'Settings.LinkName' | translate }}
      </div>
      <input
        class="expanded-info-input"
        formControlName="linkName"
        [(ngModel)]="companiesService.currentCompany.linkName"
      />
    </div>
  </div>

  <div class="expanded-info-parent">
    <div *ngIf="roleAllowed()" class="expanded-info-column">
      <div class="expanded-info-title" matTooltip="{{ 'Shared.Mandatory' | translate }}">
        {{ ('Settings.IP' | translate) + (isEdit() ? '' : '*') }}
      </div>
      <mat-form-field appearance="none" class="remove-infix">
        <mat-select
          formControlName="ip"
          name="ip"
          [required]="!isEdit()"
          [disabled]="isIpDisabled === 'ip-disabled'"
          #selectedServerRef
          class="text-style-input expanded-info-input"
          (selectionChange)="setServer($event.value)"
          [style.background-color]="isIpDisabled === 'ip-disabled' ? '#F9F9F9' : 'transparent'"
          style="width: 300px"
        >
          <mat-option
            class="text-style-input"
            [value]="server.ip"
            *ngFor="let server of receiversService.receiverServers"
          >
            {{ server.name }} - {{ server.location }}
          </mat-option>
        </mat-select>
        <div *ngIf="getError('ip')" class="expanded-info-detail error">
          <span *ngIf="getErrorType('ip', 'required')">{{ 'Settings.ErrorControl.RequiredField' | translate }}</span>
        </div>
      </mat-form-field>
    </div>

    <div class="expanded-info-column">
      <div class="expanded-info-title">
        {{ 'Settings.Location' | translate }}
      </div>
      <input class="expanded-info-input" matInput formControlName="location" [(ngModel)]="location" />
      <div *ngIf="getError('location')" class="expanded-info-detail error">
        <span *ngIf="getErrorType('location', 'invalidParam')">{{
          'Settings.ErrorControl.CoordFormat' | translate
        }}</span>
      </div>
    </div>
  </div>

  <div class="row-container">
    <app-company-edit-customize
      class="info-container info-container-logo middle-scrollable enable-click"
      style="height: 100%"
    >
    </app-company-edit-customize>

    <div class="row">
      <div style="display: flex; align-items: center; gap: 15px">
        <div *ngIf="isAdmin()">
          <button [disabled]="isAddReceiverButtonDisabled()" mat-raised-button color="primary" (click)="addReceiver()">
            <div style="display: flex; align-items: center; gap: 15px">
              <mat-icon>add</mat-icon>
              <div>
                {{ 'Settings.AddReceiver' | translate }}
              </div>
            </div>
          </button>
          <mat-icon
            class="info-icon"
            matTooltip="{{
              ('Settings.AddReceiverDetails' | translate) +
                ' (' +
                ('Settings.AutomaticCreationOfReceiver' | translate) +
                ')'
            }}"
            >info</mat-icon
          >
        </div>
      </div>
    </div>

    <div class="row">
      <div style="display: flex; align-items: center; gap: 15px">
        <button mat-raised-button color="primary" (click)="addUser()">
          <div style="display: flex; align-items: center; gap: 15px">
            <mat-icon>add</mat-icon>
            <div>
              {{ 'Settings.AddUser' | translate }}
            </div>
          </div>
        </button>
      </div>
    </div>
  </div>
</form>

<div style="margin-top: 30px">
  <app-company-edit-users
    [isEdit]="isEdit()"
    [addReceiver]="addReceiverEvent"
    [addUser]="addUserEvent"
    class="info-container middle-scrollable enable-click"
  >
  </app-company-edit-users>
  <app-company-edit-settings *ngIf="isEdit()" class="info-container middle-scrollable enable-click">
  </app-company-edit-settings>
</div>
